

export const Apirequests = async function (path, method = "POST", bodyObj, headers) {
    let requestOptions = {
        method: method,
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
            ...headers
        }
    };

    // Only include body if method is not GET
    if (method !== "GET") {
        requestOptions.body = JSON.stringify(bodyObj);
    }

    // console.log(`${process.env.REACT_APP_SERVER_URI}${path}`,'url')
    const response = await fetch(`${process.env.REACT_APP_SERVER_URI}${path}`, requestOptions);
    const data = await response.json();
    return data;
}




export const Apirequests2 = async function (
    path,
    method = "POST",
    bodyObj,
    headers = {}
) {
    const requestOptions = {
        method,
        mode: "cors",
        headers: {
            ...headers,
        },
    };

    // IMPORTANT:
    // Do not set Content-Type for FormData.
    // Browser will automatically add:
    // multipart/form-data; boundary=....
    if (method !== "GET" && bodyObj !== undefined) {
        requestOptions.body = bodyObj;
    }

    const response = await fetch(
        `${process.env.REACT_APP_SERVER_URI}${path}`,
        requestOptions
    );

    const data = await response.json();

    if (!response.ok) {
        throw {
            response: {
                status: response.status,
                data,
            },
        };
    }

    return data;
};